import {MatchClockStatus} from "@atg-sport-shared/pool-types/matchTypes";

import {
    ADD_MATCH_CLOCK,
    START_MATCH_CLOCK,
    STOP_MATCH_CLOCK,
    UPDATE_MATCH_CLOCK,
} from "./matchClockActions";

import type {
    AddMatchClockAction,
    StartMatchClockAction,
    StopMatchClockAction,
    UpdateMatchClockAction,
} from "./matchClockActions";
import type {MatchClockState} from "@atg-sport-shared/pool-types";
import type {Reducer, AnyAction} from "redux";

const initialState: MatchClockState = {};

/**
 * Calculate the period based on sport type and minute
 * @param sport - The sport type (e.g., "hockey", "football")
 * @param minute - The current minute of the match
 * @returns The calculated period number
 */
const calculatePeriod = (sport: string | undefined, minute: number): number => {
    const sportLower = sport?.toLowerCase();

    if (sportLower === "hockey") {
        if (minute < 20) return 1;
        if (minute < 40) return 2;
        return 3;
    }

    // Default to football logic
    return minute > 0 ? 2 : 1;
};

export const matchClockReducer: Reducer<MatchClockState> = (
    state: MatchClockState = initialState,
    _action: AnyAction,
) => {
    const action = _action as
        | StartMatchClockAction
        | UpdateMatchClockAction
        | StopMatchClockAction
        | AddMatchClockAction;

    switch (action.type) {
        case START_MATCH_CLOCK: {
            const {matchId, minute = 0, sport} = action.payload;

            const newClock = {
                ...state,
                [matchId]: {
                    ...state[matchId],
                    minute,
                    status: MatchClockStatus.Ongoing,
                    period: calculatePeriod(sport, minute),
                },
            };

            return newClock;
        }
        case UPDATE_MATCH_CLOCK: {
            const {matchId, minute} = action.payload;

            return {
                ...state,
                [matchId]: {
                    ...state[matchId],
                    minute,
                },
            };
        }
        case STOP_MATCH_CLOCK: {
            const {matchId} = action.payload;

            return {
                ...state,
                [matchId]: {
                    ...state[matchId],
                    status: MatchClockStatus.Stopped,
                },
            };
        }
        case ADD_MATCH_CLOCK: {
            const {matchId, minute} = action.payload;

            return {
                ...state,
                [matchId]: {
                    ...state[matchId],
                    minute,
                    period: 1,
                    status: MatchClockStatus.Stopped,
                },
            };
        }
        default: {
            return state;
        }
    }
};
